import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Alert, AlertDescription } from '../components/ui/alert';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card';
import { PAGE_ROOT } from '../components/work/page-chrome';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const userId = params.get('uid') || '';

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    setFailed(false);
    const res = await fetch('/api/auth/reset', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, userId, password }),
    });
    if (res.ok) {
      setMsg('Password updated. Redirecting to login...');
      setTimeout(() => navigate('/'), 1200);
    } else {
      setFailed(true);
      setMsg('Reset failed. Link may be invalid or expired.');
    }
  }

  return (
    <div className={PAGE_ROOT}>
      <main className="flex justify-center px-4 py-16">
        <Card className="w-full max-w-sm">
          <CardHeader>
            <CardTitle>Reset password</CardTitle>
            <CardDescription>Choose a new password for this account.</CardDescription>
          </CardHeader>
          <CardContent>
            <form className="space-y-4" onSubmit={submit}>
              <div className="grid gap-2">
                <Label htmlFor="password">New password</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              {msg ? (
                <Alert variant={failed ? 'destructive' : 'default'}>
                  <AlertDescription>{msg}</AlertDescription>
                </Alert>
              ) : null}
              <Button type="submit" className="w-full">
                Update password
              </Button>
            </form>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
